module.exports = __webpack_public_path__ + "img/about-m-slide-3.37cb506a.jpg";